export const DISMISS_DEEP_LINK_BANNER = 'dismiss-deep-link-banner';

const dismissDeepLinkBanner = ({ category }) => ({
  type: DISMISS_DEEP_LINK_BANNER,
  payload: {
    category,
  },
});
export default dismissDeepLinkBanner;
